import { Eye, EyeOff } from "lucide-react";
import { useState } from "react";

const PasswordCell = ({ password }) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className="flex items-center gap-2">
      <p className="font-medium text-slate-900 dark:text-slate-400">
        {showPassword ? password : "•".repeat(password?.length || 8)}
      </p>

      <button
        type="button"
        onClick={() => setShowPassword(!showPassword)}
        className="text-slate-500 hover:text-slate-700 dark:hover:text-white"
      >
        {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
      </button>
    </div>
  );
};

export default PasswordCell;
